import React, { useEffect, useReducer, useState } from 'react';
import {
  CdtDetailContainer,
  CdtDetailWrapper,
  CdtDetailContent,
  CdtDetailHeader,
  CdtDetailFooter,
  CdtDetailFooterLabel,
  CdtDetailFooterPrice,
  CdtDetailFooterValue,
  CdtDetailFooterValueInfo,
  CdtHeaderIcon,
  CdtMainDetail,
  CdtDetailBodyLabel,
  CdtDetailBodyValue,
  CdtBoxDetailContent,
  CdtDetailHeaderGrid,
  CdtDetailBodyLine,
  CdtDetailSubTitle,
  CdtDetailFinishedContent,
  CdtDetailHalfBox
} from './styles';
import { H4 } from '../../components/Typography/styles';
import { BsPersonCheck, BsChevronDown } from 'react-icons/bs';
import { BsInfo } from 'react-icons/bs';
import ModalAction from '../../components/ModalAction'; import Copyright from '../../components/Copyright';
import { CdtSteps, CdtFrequency } from '../../helpers/enum';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import Loader from '../../components/Loader';
import { useLocation } from 'react-router-dom';
import { default as CdtDetailTypes } from '../../store/Simulator/types';
import { formatPhone } from '../../helpers/string';
import { formatData, formatDateToDefaultUS } from '../../helpers/date';
import { formatPrice } from '../../helpers/price';
const CdtDetail = () => {
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(CdtSteps.DEFAULT);
  const [lastStep, setLastStep] = useState(CdtSteps.DEFAULT);
  const [finished, setFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [detail, setDetail] = useState({});

  async function initializedStateComponent() {
    try {
      if (location.state) {
        await setDetail(location.state);
        const step = CdtSteps[location.state.estado];
        await setActiveStep(step);
        await setLastStep(step - 1);
        await setFinished(CdtSteps[location.state.estado] == CdtSteps.FINISHED);
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    initializedStateComponent();
  }, [])

  return (
    <CdtDetailContainer id="cdt-detail-page">
      <CdtDetailWrapper>
        {isLoading ? <Loader /> : (
          <CdtDetailContent>
            <CdtDetailHeader>
              <CdtDetailHeaderGrid>
                <CdtHeaderIcon>
                  <BsPersonCheck size={20} color={colors.bgPrimary} id="person-check-icon" />
                </CdtHeaderIcon>
                <CdtMainDetail>{detail.nombre}<br />
                  {detail.email}<br />
                  {detail.documento.tipo + " " + detail.documento.numero}</CdtMainDetail>
              </CdtDetailHeaderGrid>
              <CdtBoxDetailContent>
                <CdtDetailBodyLine>
                  <CdtDetailBodyLabel>Inversión: </CdtDetailBodyLabel>
                  <CdtDetailBodyValue>{formatPrice(parseFloat(detail.monto.balance))}</CdtDetailBodyValue>
                </CdtDetailBodyLine>
                <CdtDetailBodyLine>
                  <CdtDetailBodyLabel>Plazo: </CdtDetailBodyLabel>
                  <CdtDetailBodyValue>{detail.terminoDias + " días"}</CdtDetailBodyValue>
                </CdtDetailBodyLine>
                <CdtDetailBodyLine>
                  <CdtDetailBodyLabel>Tasa: </CdtDetailBodyLabel>
                  <CdtDetailBodyValue>{parseFloat(detail.intereses.tasa)+"%"}</CdtDetailBodyValue>
                </CdtDetailBodyLine>
                <CdtDetailBodyLine>
                  <CdtDetailBodyLabel>Rendimientos: </CdtDetailBodyLabel>
                  <CdtDetailBodyValue>{detail.intereses.rendimientos}</CdtDetailBodyValue>
                </CdtDetailBodyLine>
                <CdtDetailBodyLine>
                  <CdtDetailBodyLabel>Periodicidad de Pago:</CdtDetailBodyLabel>
                  <CdtDetailBodyValue>{CdtFrequency[detail.intereses.periodicidad]}</CdtDetailBodyValue>
                </CdtDetailBodyLine>
              </CdtBoxDetailContent>
              {finished &&
                <CdtDetailFinishedContent>
                  <CdtDetailBodyLine>
                    <CdtDetailHalfBox>
                      Fecha ingreso:<br/>
                      {formatData(location.state.fechaCreacion)}
                    </CdtDetailHalfBox>
                    <CdtDetailHalfBox>
                      Fecha vencimiento:<br/>
                      {formatData(location.state.mambu.lastAccountAppraisalDate)}
                    </CdtDetailHalfBox>
                  </CdtDetailBodyLine>
                  <CdtBoxDetailContent>
                    <CdtDetailSubTitle>Configuraciones</CdtDetailSubTitle><br />
                    <CdtDetailBodyLine>
                      <CdtDetailBodyLabel>Cuenta desembolso</CdtDetailBodyLabel>
                      <CdtDetailBodyValue><b>{location.state.mambu._Renovacion._Autorenovacion}</b></CdtDetailBodyValue>
                    </CdtDetailBodyLine>
                    <CdtDetailBodyLine>
                      <CdtDetailBodyLabel>Autorenovación</CdtDetailBodyLabel>
                      <CdtDetailBodyValue><b>{location.state.mambu._Renovacion.autorenovacion}</b></CdtDetailBodyValue>
                    </CdtDetailBodyLine>
                  </CdtBoxDetailContent>
                </CdtDetailFinishedContent>
              }
            </CdtDetailHeader>
            {!finished &&
              <FormSteps lastStep={lastStep} steps={[
                { number: CdtSteps.WAITING_EMAIL_CONFIRMATION, label: 'Validación de correo' },
                { number: CdtSteps.WAITING_HABEAS_DATA_REVIEW, label: 'Autorizacion Habeas Data' },
                { number: CdtSteps.WAITING_IDENTITY_VALIDATION, label: 'Validación de identidad' },
                { number: CdtSteps.WAITING_ADDITIONAL_PERSONAL_DATA, label: 'Datos complementario' },
                { number: CdtSteps.WAITING_TERMS_AND_CONDITIONS_REVIEW, label: 'T&C' },
                { number: CdtSteps.WAITING_COMPLIANCE_VALIDATION, label: 'OTP y firma' },
                { number: CdtSteps.WAITING_PASSWORD, label: 'Creación de contraseña' },
                { number: CdtSteps.WAITING_PAYMENT_REQUEST, label: 'Pago' }
              ]} />
            }


          </CdtDetailContent>
        )}
      </CdtDetailWrapper>
      <Copyright />
    </CdtDetailContainer>
  )
}

export default CdtDetail;
